import { Task } from "features/Resources/Task/models";
import SendMessageForm, { SendMessageModalForm } from "features/SendMessage/SendMessageForm";
import { useTaskActionContext } from "contexts/TaskActionContext";
import { useMarkCompleteIfOpen } from "features/Resources/Task/hooks";

// this is required so the onClose is within the TaskActionButton, where the context is
function SendMessageWrapper({ task }: { task: Task }) {
  const { onClose } = useTaskActionContext();
  const markCompleteIfOpen = useMarkCompleteIfOpen(task, onClose);
  return (
    <SendMessageModalForm
      targetId={task?.messageRecipientId}
      targetType={task?.messageRecipientType}
      onClose={onClose}
      draftMessage={task?.messageBody}
      onSuccess={markCompleteIfOpen}
    />
  );
}

export function SendMessageTaskActionForm({ task }: { task: Task }) {
  return <SendMessageWrapper task={task} />;
}

export function SendMessageTaskForm({ task }: { task: Task }) {
  const markCompleteIfOpen = useMarkCompleteIfOpen(task);
  return (
    <SendMessageForm
      targetId={task?.messageRecipientId}
      targetType={task?.messageRecipientType}
      draftMessage={task?.messageBody}
      onSuccess={markCompleteIfOpen}
    />
  );
}
